import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDictionary } from "../../contexts/dictionary";
import { plans } from "../../assets/constant/plans";
import { diamond, puzzle,plus } from "../../constants/images";
import { Colors } from "../../style/colors";
import { useFormHandling } from "../../hooks/formUtils";
import { RequestConfigs } from "../../api";
import { routesMap } from "../../constants/routes";

interface Plan {
  name: string;
  price: number;
  renew: string;
  description: string;
  benefits: string[];
  crmProductId: string;
}

interface ShowAllBenefitsState {
  [planName: string]: boolean;
}

const PricingPlan: React.FC = () => {
  const { translate } = useDictionary();
  const navigate = useNavigate();
  const planstoShow: Plan[] = plans.sort((a: Plan, b: Plan) => a.price - b.price);
  const popularPlan = planstoShow[1];
  const personalPlan = planstoShow[0];
  // const familyPlusPlan = planstoShow[2];
  const [cartItem,setCartItem] = useState<CartItem>();
  const {handleClick,serverRes} = useFormHandling({requestType:RequestConfigs.addToCart,data:cartItem});
  

  const [showAllBenefits, setShowAllBenefits] = useState<ShowAllBenefitsState>({});
  const [hoveredPlan, setHoveredPlan] = useState<string | null>(null);

  const toggleBenefits = (planName: string) => {
    setShowAllBenefits((prev) => ({
      ...prev,
      [planName]: !prev[planName],
    }));
  };

  useEffect(() => {
    if (cartItem) {
      console.log(cartItem) 
      handleClick()
    }
  },[cartItem])

  useEffect(() => {
    if(serverRes?.succeeded){
      navigate(routesMap.checkoutReg.to)
    }
  },[serverRes]);

  const renderBenefits = (plan: Plan) => {
    const isExpanded = showAllBenefits[plan.name];
    const benefitsToShow = isExpanded ? plan.benefits : plan.benefits.slice(0, 10);
    return (
      <>
        <ul>
          {benefitsToShow.map((benefit, index) => (
            <li key={index}>{translate(benefit)}</li>
          ))}
        </ul>
        {plan.benefits.length > 8 && (
          <button
            className="btn btn-link p-0 mt-2"
            onClick={() => toggleBenefits(plan.name)}
          >
            {isExpanded ? translate("show_less") : translate("show_more")}
          </button>
        )}
      </>
    );
  };
  const handleChoosePlan = (product: Plan) => {
    setCartItem({product:product.crmProductId,quantity:1,list_price:product.price})
  }

  const renderPlanCard = (plan: Plan, icon: string,isPopular?:boolean) => {
    const isActive = hoveredPlan === plan.name;

    return (
      <div
        className="col-lg-4 col-sm-12 aos aos-init aos-animate"
        data-aos="fade-up"
        onMouseEnter={() => setHoveredPlan(plan.name)}
        onMouseLeave={() => setHoveredPlan(null)}
      >
        <div className={`card pricing-card ${isActive ? "active" : ""}`}>
          <div className="card-body">
            <div className="pricing-header">
              <div className="pricing-header-info">
                <div className="pricing-icon">
                  <span>
                    <img src={icon} alt="icon" />
                  </span>
                </div>
                <div className="pricing-title">
                  <h4>{translate(plan.name)}</h4>
                </div>
              </div>
              {isPopular && (
                <div>
                  <span className="badge">{translate("popular")}</span>
                </div>
              )}
            </div>
            <div className="pricing-info">
              <div className="pricing-amount">
                <h2>
                <span>{translate('starting_from')}</span> ₪{plan.price} <span>{translate(plan.renew)}</span>
                </h2>
                <p style={{ color: isActive ? Colors.whiteBackground : Colors.text  }}>{translate(plan.description)}</p>
                <h6>{translate("whats_includes")}</h6>
              </div>
              <div className="pricing-list">
                {renderBenefits(plan)}
              </div>
              <div className="pricing-btn">
                <Link to="#" onClick={()=>handleChoosePlan(plan)} className="btn btn-primary">
                {translate("choose_plan")}
                </Link>
                {/* <a href="login-email.html" className="btn btn-primary">
                  {translate("choose_plan")}
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

 

  return (
    <>
      <section className="pricing-section doc-plan" style={{width: "100%"}}>
        <div className="container">
          <div className="row">
            <div
              className="col-md-12 text-center aos aos-init aos-animate"
              data-aos="fade-up"
            >
              <div className="section-header-one">
                <h2 className="section-title">{translate("pricing_plans")}</h2>
                <p>{translate('plans_subTitle')}</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center align-items-center">
            {renderPlanCard(personalPlan, puzzle)}
            {renderPlanCard(popularPlan, plus,true)}
            {/* {renderPlanCard(familyPlusPlan, diamond)} */}
          </div>
        </div>
      </section>
    </>
  );
};

export default PricingPlan;